
import util from "@/javascript/util"
import EsQuery from '@/javascript/esQuery'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import comCalendar from '@/components/public-components/com-calendar/index.vue'
import goSearch from '@/components/lyx-components/search-box/index.vue'

export default {
name: 'goodRoute',
components: {
Tab,
TabItem,
comCalendar,
goSearch
},
data() {
return {
tabsList: [],
minHeight: 0,
infiniteStatus: false,
infiniteAll: false,
pageSize: 10,
pageNo: 0,
levalData: [{
title: '不限',
value1: '',
value2: '',
value3: '',
value4: ''
}, {
title: '500以下',
value1: '500',
value2: '',
value3: '',
value4: ''
}, {
title: '500-1000',
value1: '1000',
value2: '',
value3: '',
value4: '500'
}, {
title: '1000-2000',
value1: '2000',
value2: '',
value3: '',
value4: '1000'
}, {
title: '2000-3000',
value1: '3000',
value2: '',
value3: '',
value4: '2000'
}, {
title: '3000以上',
value1: '',
value2: '',
value3: '',
value4: '3000'
}],
daysIdx: 0,
daysData: [
{
title: '不限',
dateCount: ''
},
{
title: '一天',
dateCount: '1'
},
{
title: '二天',
dateCount: '2'
},
{
title: '三天',
dateCount: '3'
},
{
title: '四天',
dateCount: '4'
},
{
title: '五天以上',
dateCount: '5'
}
],
selectList: [{
name: '综合排序',
disTrue: false
}, {
name: '出发日期',
disTrue: false
}],
levelIdx: 0,
taListbData: ['线路', '活动'],
hotIndex: 0,
listData: [],
sortName: '综合排序',
hotTitle: '全部类型',
levalName: '筛选',
curSelect: -1,
coverOpacity: false,
sortData: [{
title: '综合排序',
sort: 'sort',
type: 'desc'
}, {
title: '价格从低到高',
sort: 'minSalePrice',
type: 'asc'
}, {
title: '价格从高到底',
sort: 'minSalePrice',
type: 'desc'
}],
sortContent: '',
sortIdx: parseInt(this.$route.params.rank),
clickStute: false,
priceItem: '',
daysItem: '',
totalNumber: 0,
zoneData: [{
allTitle: "",
cate: "",
cityId: "",
enTitle: "",
position: [],
scenic: "",
subTitle: "",
title: "不限",
}],
zoneIdx: 0,
zoneItem: '',
finishStatus: true,
stag: {
levelIdx: 0,
priceItem: '',
daysIdx: 0,
daysItem: '',
zoneIdx: 0,
zoneItem: '',
endIdx: 0,
endItem: ''
},
endIdx: 0,
endItem: '',
showDays: true,
tabIndex: 0,
startDate: {
year: '',
month: '',
day: '',
allTime: ''
},
visibility: false,
topDis: 0,
locTop: 0,
filterLayout: 0
}
},
activated() {
document.title = this.$route.params.name
},
mounted() {
this.minHeight = document.documentElement.clientHeight
this.topDis = this.$refs.searchBox.$el.offsetHeight
this.locTop = this.$refs.searchBox.$el.offsetHeight + this.$refs.kindBox.offsetHeight - 1
this.filterLayout = this.$refs.searchBox.$el.offsetHeight + this.$refs.kindBox.offsetHeight + this.$refs.stickyBox.offsetHeight - 2

document.title = this.$route.params.name


let jsonUrl = ""
this.$http.get('/api/wtcp-cms/public/news/2e041619017b45ebb0fb19a7388b74b9').then(res => {
jsonUrl = res.data.data.newsMaterials[0].fileUrl
}).then(() => {
this.$http.get('/wtcp-file' + jsonUrl).then(res => {
this.zoneData = [...this.zoneData, ...res.data]
})
})

if (this.$route.params.name) {
if (this.$route.params.name == '线路') {
this.tabIndex = 2
this.allScienceClick(this.$route.params.name, this.tabIndex)
} else if (this.$route.params.name == '活动') {
this.tabIndex = 1
this.allScienceClick(this.$route.params.name, this.tabIndex)
} else {
this.getData(true)
}
window.addEventListener("scroll", this.windowScroll)
}

/**
* 微信签名分享
*/
if (util.isWeiXin()) {
const shareData = typeof (shareData) === 'undefined' ? {
title: document.title,
desc: this.SHARE_TEXT,
imgUrl: this.SHARE_IMG,
link: window.location.href
} : shareData

this.$http.get('/api/wtcp-support/weixin/createJsapiSignature?url=' + encodeURIComponent(window.location.href.split('#')[0]) + '&appId=' + this.WX_APPID).then((response) => {
util.initWxConfig(response.data.data, shareData)
})
}
},
methods: {
clickDay(data) {
this.visibility = false
this.clickStute = false
this.startDate = data
this.listData = []
this.selectList[this.curSelect].disTrue = true
this.curSelect = -1
this.pageSize = 10
this.pageNo = 0
this.coverOpacity = false
this.infiniteStatus = false
this.infiniteAll = false
this.$nextTick(function () {
this.getData(true)
})
window.scrollTo(0, this.$refs.stickyBox.offsetTop - this.$refs.searchBox.$el.offsetHeight - this.$refs.kindBox.offsetHeight)
},
hideMask() {
this.show = false
this.coverOpacity = false
this.curSelect = -1
},
getData(status) {
const _this = this
const querystring = require('querystring')
const foodEsQuery = new EsQuery()


foodEsQuery.addSort(_this.sortData[_this.sortIdx].sort, foodEsQuery[_this.sortData[_this.sortIdx].type], false)


if (_this.hotTitle !== '全部类型') {
foodEsQuery.addString("tagNames", _this.$route.params.name, foodEsQuery.and, false)
foodEsQuery.addString("tagNames", _this.hotTitle, foodEsQuery.and, false)
} else {
foodEsQuery.addString("tagNames", _this.$route.params.name, foodEsQuery.and, false)
}

if (_this.stag.priceItem && _this.stag.priceItem.title != '不限') {
foodEsQuery.addRange("minSalePrice", _this.stag.priceItem.value1, _this.priceItem.value2, _this.priceItem.value3, _this.priceItem.value4, foodEsQuery.and, false)
}

if (_this.stag.daysItem && _this.stag.daysItem.title != '不限') {
if (_this.stag.daysIdx == 5) {
foodEsQuery.addRange("dateCount", '', '', '', _this.stag.daysItem.dateCount, foodEsQuery.and, false)
} else {
foodEsQuery.addString("dateCount", _this.stag.daysItem.dateCount, foodEsQuery.and, false)
}
}

if (_this.stag.zoneItem && _this.stag.zoneItem.title != '不限') {
foodEsQuery.addStartWith("start", _this.stag.zoneItem.title, foodEsQuery.and, false)
}

if (_this.stag.endItem && _this.stag.endItem.title != '不限') {
foodEsQuery.addPattern("dest.keyword", `*${_this.stag.endItem.title}*`, foodEsQuery.and, false)
}

if (_this.startDate.allTime != '') {
foodEsQuery.addPattern("dailyPriceDate", _this.startDate.allTime, foodEsQuery.and, false)
}
foodEsQuery.addPage(_this.pageNo * _this.pageSize, _this.pageSize)
const foodEsJsonQuery = JSON.stringify(foodEsQuery.getArray())

_this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
indexName: _this.INDEX_NAME_TYPE.ecrmRoute,
esJsonQuery: foodEsJsonQuery
})).then(res => {
const list = res.data.data ? res.data.data : []
list.forEach(item => {
if (item._source.tagNames) {
item._source.tagNames = item._source.tagNames.filter(tts => {
return tts != '置顶'
})
item._source.tagNames = item._source.tagNames.filter(tts => {
return tts != '为你推荐'
})
}
})
_this.listData = [..._this.listData, ...list]
if (list.length < _this.pageSize) {
_this.infiniteAll = true
}
_this.infiniteStatus = false
_this.clickStute = true
})
},
reset() {
this.priceItem = ''
this.daysItem = ''
this.zoneItem = ''
this.endItem = ''
this.levelIdx = 0
this.daysIdx = 0
this.zoneIdx = 0
this.endIdx = 0
this.finishStatus = true
},
finish() {
this.coverOpacity = false
this.clickStute = false
this.curSelect = -1
this.pageNo = 0
this.pageSize = 10
this.infiniteStatus = false
this.infiniteAll = false
this.totalNumber = 0
this.listData = []
if (this.levelIdx > 0) {
this.totalNumber += 1
}
if (this.daysIdx > 0) {
this.totalNumber += 1
}
if (this.zoneIdx > 0) {
this.totalNumber += 1
}
this.stag.levelIdx = this.levelIdx
this.stag.priceItem = this.priceItem
this.stag.daysIdx = this.daysIdx
this.stag.daysItem = this.daysItem
this.stag.zoneIdx = this.zoneIdx
this.stag.zoneItem = this.zoneItem
this.stag.endIdx = this.endIdx
this.stag.endItem = this.endItem

this.$nextTick(function () {
this.getData(true)
this.finishStatus = false
})
window.scrollTo(0, this.$refs.stickyBox.offsetTop - this.$refs.searchBox.$el.offsetHeight - this.$refs.kindBox.offsetHeight)
},
windowScroll: function () {

if (util.pullUpLoad()) {
this.infinite()
}
},
infinite: function () {
if (this.listData.length == 0) {
return
}
if (this.infiniteAll) {
return
}
if (this.infiniteStatus) {
return
}
this.infiniteStatus = true
if (this.clickStute) {
this.pageNo += 1
this.getData()
}
},

sortSelBtn(item, index) {
this.listData = []
this.sortName = item.title
this.sortIdx = index
this.clickStute = false
this.selectList[this.curSelect].name = item.title
this.selectList[this.curSelect].disTrue = true
this.curSelect = -1
this.pageSize = 10
this.pageNo = 0
this.coverOpacity = false
this.infiniteStatus = false
this.infiniteAll = false
this.$nextTick(function () {
this.getData(true)
})
window.scrollTo(0, this.$refs.stickyBox.offsetTop - this.$refs.searchBox.$el.offsetHeight - this.$refs.kindBox.offsetHeight)
},

allScienceClick(name, index) {
this.clickStute = false
this.hotTitle = name
this.listData = []
this.hotIndex = index
this.curSelect = -1
this.pageSize = 10
this.pageNo = 0
this.coverOpacity = false
this.infiniteStatus = false
this.infiniteAll = false
if (index == 1) {
this.showDays = false
} else {
this.showDays = true
}
this.sortName = this.sortData[0].title
this.sortIdx = 0
this.selectList[0].name = this.sortData[0].title
this.selectList[0].disTrue = false
this.selectList[1].disTrue = false,
this.startDate = {
year: '',
month: '',
day: '',
allTime: ''
}
this.selectList[2].disTrue = false
this.totalNumber = 0
this.levelIdx = 0
this.priceItem = ''
this.stag.levelIdx = 0
this.stag.priceItem = ''
this.daysIdx = 0
this.daysItem = ''
this.stag.daysIdx = 0
this.stag.daysItem = ''
this.zoneIdx = 0
this.zoneItem = ''
this.stag.zoneIdx = 0
this.stag.zoneItem = ''
this.endIdx = 0
this.endItem = ''
this.stag.endIdx = 0
this.stag.endItem = ''
this.daysIdx = 0
this.daysItem = ''
this.stag.daysIdx = 0
this.stag.daysItem = ''
this.$nextTick(function () {
this.getData(true)
})
window.scrollTo(0, this.$refs.stickyBox.offsetTop - this.$refs.searchBox.$el.offsetHeight - this.$refs.kindBox.offsetHeight)
},
slectSx(index) {
const _this = this
if (_this.curSelect == -1 || _this.curSelect != index) {
_this.coverOpacity = true
_this.curSelect = index
if (index == 1) {
_this.visibility = true
} else {
_this.visibility = false
}
if (index == 2 && _this.finishStatus) {
_this.priceItem = _this.stag.priceItem
_this.levelIdx = _this.stag.levelIdx
_this.daysItem = _this.stag.daysItem
_this.daysIdx = _this.stag.daysIdx
_this.zoneItem = _this.stag.zoneItem
_this.zoneIdx = _this.stag.zoneIdx
_this.endItem = _this.stag.endItem
_this.endIdx = _this.stag.endIdx
} else {
_this.finishStatus = true
}
} else if (_this.curSelect == index) {
_this.coverOpacity = false
_this.curSelect = -1
}
window.scrollTo(0, _this.$refs.stickyBox.offsetTop - _this.$refs.searchBox.$el.offsetHeight - this.$refs.kindBox.offsetHeight)
},

levalClick(item, index) {
this.levelIdx = index
this.priceItem = item
this.selectList[this.curSelect].disTrue = true
},

daysClick(item, index) {
this.daysIdx = index
this.daysItem = item
this.selectList[this.curSelect].disTrue = true
},

zoneClick(item, index) {
this.zoneIdx = index
this.zoneItem = item
this.selectList[this.curSelect].disTrue = true
},

endClick(item, index) {
this.endIdx = index
this.endItem = item
this.selectList[this.curSelect].disTrue = true
}
}
}
